document.addEventListener('DOMContentLoaded', function () {
  var mediaQuery = window.matchMedia('(min-width: 990px)');
  var scrollSelector = '.sticky-container .sticky-container-inner';

  function getScrollableElement() {
    return document.querySelector(scrollSelector);
  }

  function hasSlimScroll() {
    return window.jQuery && typeof window.jQuery.fn.slimScroll === 'function';
  }

  function destroySlimScroll($target) {
    if (!$target.length || !$target.parent().hasClass('slimScrollDiv')) return;

    // 切换到移动端时移除 slimScroll 包裹层，避免影响正常页面流。
    $target.slimScroll({ destroy: true });
    $target.attr('style', '');
  }

  function initCommunitySidebarScroll() {
    var scrollElement = getScrollableElement();
    if (!scrollElement || !hasSlimScroll()) return;

    var $target = window.jQuery(scrollElement);

    if (!mediaQuery.matches) {
      destroySlimScroll($target);
      return;
    }

    if ($target.parent().hasClass('slimScrollDiv')) return;

    // PC 端侧栏限高后使用 slimScroll，保持滚动条样式和文章页一致。
    $target.slimScroll({
      width: 'auto', // 可滚动区域宽度
      height: '100%', // 可滚动区域高度
      size: '4px', // 组件宽度
      color: 'rgb(184, 180, 178)', // 滚动条颜色
      position: 'right', // 组件位置：left/right
      distance: '0px', // 组件与侧边之间的距离
      start: 'top', // 默认滚动位置：top/bottom
      opacity: 0, // 滚动条透明度
      alwaysVisible: false, // 是否始终显示组件
      disableFadeOut: true, // 是否鼠标经过可滚动区域时显示组件，离开时隐藏组件
      railVisible: true, // 是否显示轨道
      railColor: 'rgb(232, 231, 230)', // 轨道颜色
      railOpacity: 1, // 轨道透明度
      railDraggable: true, // 是否滚动条可拖动
      railClass: 'slimScrollRail', // 轨道 div 类名
      barClass: 'slimScrollBar', // 滚动条 div 类名
      wrapperClass: 'slimScrollDiv', // 外包 div 类名
      allowPageScroll: true, // 是否使用滚轮到达顶端/底端时滚动窗口
      wheelStep: 10, // 滚轮滚动量
      touchScrollStep: 10, // 用户使用手势时的滚动量
      borderRadius: '7px', // 滚动条圆角
      railBorderRadius: '7px' // 轨道圆角
    });
  }

  initCommunitySidebarScroll();

  mediaQuery.addEventListener('change', initCommunitySidebarScroll);
});
